export function debounce(fn, msTimeout) {
  let timeoutId = null;

  return function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, arguments), msTimeout);
  };
}

// валидация email или tel
function regexValidator(input, regex) {
  if (!input) {
    console.error("regexValidator — input is null");
    return false;
  }
  if (regex.test(input.value)) {
    input.classList.remove("invalid");
    return true;
  }

  input.classList.add("invalid");
  return false;
}
const validatorPhone = debounce((input) => {
  const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{5}$/i;
  return regexValidator(input, regex);
}, 800);

const validatorEmail = debounce((input) => {
  const regex = /^[A-Z0-9.!#$%&'*+-/=?^_`{|}~]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return regexValidator(input, regex);
}, 800);

const kwValidator = (e) => {
  if (e.target.type === "tel") {
    validatorPhone(e.target);
  } else if (e.target.type === "email") {
    validatorEmail(e.target);
  }
};

function inputTelOrEmailHandler(e) {
  e.target.classList.remove("invalid");
  kwValidator(e);
}

(() => {
  document.querySelectorAll("input.kw-validator").forEach((el) => {
    for (let ev of ["input", "blur", "focus"]) {
      el.addEventListener(ev, inputTelOrEmailHandler, {
        passive: true,
      });
    }
  });
})();
